import { Grid } from "@material-ui/core";
import { Rating } from "@mui/material"
import { vendorFeedbackTypeLabel } from "../consts";

export const VendorRating = ({ feedbackType, value, onChange, readOnly }) => {
    const rating = <Rating
        size="small"
        precision={1}
        value={value}
        onChange={onChange}
        readOnly={!!readOnly}
    />;
    return (
        <>
            {feedbackType ? <Grid container spacing={1} alignItems="center">
                {/* <Grid item >
                    {vendorFeedbackTypeLabel[feedbackType]?.minDescription}
                </Grid> */}
                <Grid item >
                    {rating}
                </Grid>
                {/* <Grid item >
                    {vendorFeedbackTypeLabel[feedbackType]?.maxDescription}
                </Grid> */}
            </Grid> : rating}
        </>
    );
};